import {
  EMAIL_VALIDATOR,
  PHONE_VALIDATOR,
  LENGTH_VALIDATOR,
  MIN_VALIDATOR,
  ZIP_CODE_VALIDATOR,
  PASSWORD_VALIDATOR,
  PASSWORDS_DO_NOT_MATCH,
  EMAIL_DO_NOT_MATCH,
  NIP_VALIDATOR,
  SPECIAL_CHARACTER_VALIDATOR,
  ONLY_NUMBER_VALIDATOR,
  ONLY_TEXT_VALIDATOR,
  LAST_NAME_VALIDATOR
} from "../../messages/errorsMessages";

export const phoneValidator = (required: boolean) => ({
  required,
  pattern: {
    // value: /(([+][0-9]{2}[.-]?)?[0-9]{3}([.-]?)[0-9]{3}([.-]?)[0-9]{3})|^$/,
    value: /^[0-9]{9}$/,
    message: PHONE_VALIDATOR
  }
});

export const emailValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /(^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$)|^$/,
    message: EMAIL_VALIDATOR
  }
});

export const lengthValidator = (required: boolean, minLength: number) => ({
  required,
  minLength: {
    value: minLength,
    message: LENGTH_VALIDATOR(minLength)
  }
});

export const minValue = (required: boolean, min: number) => ({
  required,
  min: {
    value: min,
    message: MIN_VALIDATOR(min)
  }
});

export const zipCodeValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^\d{2}-\d{3}$/,
    message: ZIP_CODE_VALIDATOR
  }
});

export const passValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,64}$/,
    message: PASSWORD_VALIDATOR
  }
});

export const nipValidator = (required: boolean) => ({
  required,
  pattern: {
    // value: /(([0-9]{10}))|^$/,
    value: /^\d{10}$/,
    message: NIP_VALIDATOR
  }
});

export const lastNameValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+(-[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+)?$/,
    message: LAST_NAME_VALIDATOR
  }
});

export const repeatPassValidator = (required: boolean, currentValue: string) => ({
  required,
  validate: (value: string) => value === currentValue || PASSWORDS_DO_NOT_MATCH
});

export const repeatEmailValidator = (required: boolean, currentValue: string) => ({
  required,
  validate: (value: string) => value === currentValue || EMAIL_DO_NOT_MATCH
});

export const onlyTextValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]+$/,
    message: ONLY_TEXT_VALIDATOR
  }
});

export const onlyNumberValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^[0-9]+$/,
    message: ONLY_NUMBER_VALIDATOR
  }
});

export const specialCharacterValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^[a-zA-Z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]+$/,
    message: SPECIAL_CHARACTER_VALIDATOR
  }
});
